const initialState = {
    list: [],
    error: {}
};

const FileUploadReducer = (state, action) => {
    if (state === null || state === undefined) {
        state = initialState;
    }
    switch (action.type) {
        case "GET_FOLDER_CATEGORY_SUCCESS":
            state = {
                ...state,
                list: [...action.payload]

            };
            return state;
        case "GET_FOLDER_CATEGORY_ERROR":
            state = {
                ...state,
                error: action.payload
            };
            return state;
        default:
            return state;
    }
};

export default FileUploadReducer;
